import React from 'react';
import styles from './styles.module.css';

export interface PageHeaderProps extends React.HTMLAttributes<HTMLElement> {
  title: string;
  breadcrumb?: React.ReactNode;
  action?: React.ReactNode;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  breadcrumb,
  action,
  className = '',
  children,
  ...props
}) => {
  return (
    <header className={`${styles.pageHeader} ${className}`} {...props}>
      <div className={styles.inner}>
        {breadcrumb && <div className={styles.breadcrumb}>{breadcrumb}</div>}

        <div className={styles.headerRow}>
          <h1 className={styles.title}>{title}</h1>
          {action && <div className={styles.action}>{action}</div>}
        </div>

        {children && <div className={styles.content}>{children}</div>}
      </div>
    </header>
  );
};
